import { DELETE_ERROR } from './action-types';

export function deleteError() {
  return {
    type: DELETE_ERROR,
  };
}
